import { render, staticRenderFns } from "./aventraLaravel.vue?vue&type=template&id=741d8ce2&"
import script from "./aventraLaravel.vue?vue&type=script&lang=js&"
export * from "./aventraLaravel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports